export default {
      id: "editor-placeholders-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#editor-placeholders",
      toString: function () {
        return this.url;
      }
    }